import formatCurrency from 'format-currency';

class CostPlusInvoiceViewController {
  currency(value) {
    return formatCurrency(value);
  }

  percent(value) {
    if (value == null || isNaN(value)) {
      return '—';
    }
    return (Number(value) * 100).toFixed(2) + '%';
  }

  editHours(row, $event) {
    if ($event) {
      $event.preventDefault();
      $event.stopPropagation();
    }
    if (!row || !row.lineItemId || !this.canManage) {
      return;
    }
    this.onEditHours({ lineItemId: row.lineItemId });
  }

  removeLine(row, $event) {
    if ($event) {
      $event.preventDefault();
      $event.stopPropagation();
    }
    if (!row || !row.lineItemId || !this.canManage) {
      return;
    }
    this.onRemoveLine({ lineItemId: row.lineItemId });
  }
}

export default CostPlusInvoiceViewController;



// WEBPACK FOOTER //
// ./client/pages/admin/invoice-details/views/cost-plus-invoice-view/cost-plus-invoice-view.controller.js